import React, {useEffect, useState} from 'react';
import Modal from "../../../shared/ui/modal/Modal";
import PreviewGenerator from "./preview-social-network/PreviewGenerator";
import Button from "../../../shared/ui/button/Button";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import {TimePicker} from "react-time-picker";
import {useSelector} from "react-redux";
import {selectToken} from "../../../store/selectors/authSelectors";
import {useNavigate, useParams} from "react-router-dom";
import {useAppDispatch} from "../../../store/store";
import {shareProjectOnLinkedIn} from "../../../store/slices/projectSlice";
interface PostScriptProps {
    isShowModal: boolean;
    onClose:() => void;
    postText: string;
    image: string|null;
    header:string;

}
type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];
const getCurrentTime = (): string => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0'); // Add leading zero if necessary
    const minutes = String(now.getMinutes()).padStart(2, '0'); // Add leading zero if necessary
    return `${hours}:${minutes}`;
};
const PostScript: React.FC<PostScriptProps> = ({isShowModal,onClose,postText,image,header}) => {
    const [isCalendarVisible, setIsCalendarVisible] = useState(false);
    const [value, onChange] = useState<Value>(null);
    const [selectedTime, setSelectedTime] = useState<string | null>(getCurrentTime());
    const token=useSelector(selectToken)
    const {projectId}=useParams();

    const handleSchedule = () => {
        onClose()
    };


    const handlePost=async ()=>{
        if(token!=null){
            const apiBaseUrl =  process.env.REACT_APP_API_URL;

            const user = token.split("|")[0];
            const redirectUri = `${window.location.origin}/text_editor/${projectId}`;
            const authUrl = `${apiBaseUrl}/auth/linkedin?user=${user}&redirect_uri=${encodeURIComponent(`${redirectUri}?shared=true`)}`;

            window.location.href = authUrl;
            onClose()

        }


    }

    const handleTimeChange = (time: string | null) => {
        setSelectedTime(time);
    };

    const handleOnClose=()=>{
        onClose()
        setSelectedTime(getCurrentTime())
        onChange(null)
        setIsCalendarVisible(false)
    }
    return(
        <Modal isOpen={isShowModal} onClose={handleOnClose} header={header} width={'500px'}>
            <div>
                <PreviewGenerator postText={postText} image={image}/>
                {isCalendarVisible ? (
                        <>
                            <div style={{

                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                marginBottom: '20px',
                                gap: '10px'
                            }}>
                                <Calendar onChange={onChange} value={value}/>
                                <TimePicker onChange={handleTimeChange} value={selectedTime} clockIcon={false}
                                            disableClock={true}/>
                                <Button onClick={handleSchedule} text={'Schedule Post'}/>
                            </div>
                        </>

                    ) :
                    <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', gap: '10px'}}>
                        <Button onClick={handlePost} text={'Post Now'}/>
                        {/*<Button onClick={() => setIsCalendarVisible(true)} text={'Schedule For Later'}*/}
                        {/*        type={'secondary'}/>*/}
                    </div>}


            </div>
        </Modal>
    )
}
export default PostScript